import type { IconNode } from '../types';

/**
 * @name coconut
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8ZWxsaXBzZSBjeD0iMTIiIGN5PSI5IiByeD0iMTAiIHJ5PSI3IiAvPgogIDxwYXRoIGQ9Ik0yIDl2M2ExMCAxMCAwIDAgMCAyMCAwVjkiIC8+CiAgPGVsbGlwc2UgY3g9IjEyIiBjeT0iOSIgcng9IjYiIHJ5PSIzIiAvPgogIDxwYXRoIGQ9Im0xNCA4IDYtNmgyIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/coconut
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const coconut: IconNode = [
  ['ellipse', { cx: '12', cy: '9', rx: '10', ry: '7', key: '1dbdvm' }],
  ['path', { d: 'M2 9v3a10 10 0 0 0 20 0V9', key: 'cl4bp1' }],
  ['ellipse', { cx: '12', cy: '9', rx: '6', ry: '3', key: '12b5m6' }],
  ['path', { d: 'm14 8 6-6h2', key: '1au6m1' }],
];

export default coconut;
